import React, { useEffect, useState } from 'react';
import { useCurrentRoute, useNavigation } from 'react-navi';
import {
  EntryCard,
  NavBar,
  Prize,
  Entry, EntriesNavBar,
} from '@contest-web/components/src/components';
import classNames from 'classnames';
import { EntriesRepository } from '../repositories/entries';
import * as localForage from 'localforage';

function EntriesApp(props: {
  modalTitle: string;
  title: React.ReactNode;
  list: Entry[];
  isSummary?: boolean;
  url?: string;
  isFinal?: boolean;
}) {
  let navigation = useNavigation();
  let route = useCurrentRoute();
  let { url, list } = props;
  const key = `favorites`;
  const backgroundClass = props.isFinal ? "is-dark is-gradient" : "is-dark";
  const [loading, setLoading] = useState(false);
  const [favorites, setFavorites] = useState<Entry[]>([]);
  const [entries, setEntries] = useState<Entry[]>(list);
  // Initial Data Fetching...
  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const result: number[] = (await localForage.getItem(key)) || [];
      let favorites: Entry[] = [];
      result.forEach(id => {
        const [entry] = list.filter(entry => entry.id === id);
        entry && favorites.push(entry);
      });
      setFavorites(favorites);
      setEntries(list.filter(entry => !(result || []).includes(entry.id)));
      setLoading(false);
    };
    fetch();
  }, [props.list]);

  if (loading) {
    return (
      <div>
        <div className={classNames('hero', backgroundClass)}>
          <div className="hero-head">
            <NavBar
              logoImageSrc="/images/logo_white.svg"
              entryUrl={`${process.env.REACT_APP_ENTRY_FORM_URL}${route.url.search}`}
            />
          </div>
          <div className="hero-body">
            <div className="container">{props.title}</div>
          </div>
        </div>
        <section className="section" style={{ background: '#f6f6f6', minHeight: '100vh' }} />
      </div>
    );
  }

  return (
    <div>
      <div className={classNames('hero', backgroundClass)}>
        <div className="hero-head">
          <NavBar
            logoImageSrc="/images/logo_white.svg"
            entryUrl={`${process.env.REACT_APP_ENTRY_FORM_URL}${route.url.search}`}
          />
        </div>
        <div className="hero-body">
          <div className="container">{props.title}</div>
        </div>
      </div>
      <section className="section" style={{ background: '#f6f6f6' }}>
        <div className="container is-slim">
          {props.isFinal && <div className="notification is-white has-text-centered is-size-7 has-text-primary">審査期間は終了しました。<br/>審査の結果は<a className="has-text-weight-bold" href="/news/2019-10-04">2019年11月17日（日）表彰式</a>にて発表させていただきます。<br />
              多くの皆さまにご参加いただき、誠にありがとうございました。</div>}
          {favorites.length > 0 && (
            <>
              <p className="is-margin-bottom-2 has-text-centered">
                <button
                  className="button tooltip is-rounded is-white"
                  data-tooltip="閲覧環境に保存したお気に入りを固定で表示します"
                >
                  <span className="is-family-secondary has-text-primary has-text-weight-bold">FAVORITES</span>
                  <span className="icon has-text-grey-light">
                    <i className="far fa-question-circle" />
                  </span>
                </button>
              </p>
              <div className="columns is-variable is-multiline is-mobile is-mobile-2 is-margin-bottom-4">
                {favorites.map((entry, index) => (
                  <div key={index} className="column is-one-third-desktop is-one-third-tablet is-half-mobile">
                    <EntryCard
                      onClick={async () => {
                        const [_entry] = await Promise.all([
                          EntriesRepository.getEntry(entry.id, { prize: Prize.second }),
                          EntriesRepository.getProfile(entry.id),
                        ]);
                        if (_entry) {
                          navigation.navigate(`/profile/${entry.id}`);
                        }
                      }}
                      lazy
                      entryNumber={entry.id}
                      url={url}
                      name={entry.name || ''}
                      college={entry.college || ''}
                      twitter={entry.twitter || ''}
                      instagram={entry.instagram || ''}
                      circle={entry.circle || ''}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
          {entries.length > 0 && (
            <>
              <p className="is-margin-bottom-2 has-text-centered">
                <a className="button is-rounded is-white">
                  <span className="is-family-secondary has-text-primary has-text-weight-bold">ENTRIES</span>
                </a>
              </p>
              <div className="columns is-variable is-multiline is-mobile is-mobile-2 is-margin-bottom-2">
                {entries.map(
                  (entry, index): any => (
                    <div key={index} className="column is-one-third-desktop is-one-third-tablet is-half-mobile">
                      <EntryCard
                        onClick={async () => {
                          const [_entry] = await Promise.all([
                            EntriesRepository.getEntry(entry.id, { prize: Prize.second }),
                            EntriesRepository.getProfile(entry.id),
                          ]);
                          if (_entry) {
                            navigation.navigate(`/profile/${entry.id}`);
                          }
                        }}
                        lazy
                        entryNumber={entry.id}
                        url={url}
                        name={entry.name || ''}
                        college={entry.college || ''}
                        twitter={entry.twitter || ''}
                        instagram={entry.instagram || ''}
                      />
                    </div>
                  ),
                )}
              </div>
            </>
          )}
        </div>
      </section>
      {/* 受賞者一覧 */}
      <EntriesNavBar />
    </div>
  );
}

export default EntriesApp;
